"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSummary = exports.User = exports.UserRole = exports.MailNotiStatus = exports.UserType = void 0;
var UserType;
(function (UserType) {
    UserType["User"] = "USER";
    UserType["Ecoa"] = "ECOA";
})(UserType = exports.UserType || (exports.UserType = {}));
var MailNotiStatus;
(function (MailNotiStatus) {
    MailNotiStatus["Wait"] = "WAIT";
    MailNotiStatus["Preparing"] = "PREPARING";
    MailNotiStatus["Prepared"] = "PREPARED";
    MailNotiStatus["None"] = "NONE";
    MailNotiStatus["Failed"] = "FAILED";
})(MailNotiStatus = exports.MailNotiStatus || (exports.MailNotiStatus = {}));
class UserRole {
}
exports.UserRole = UserRole;
class User {
}
exports.User = User;
class UserSummary {
}
exports.UserSummary = UserSummary;
//# sourceMappingURL=user.js.map